import {LoadingButton} from "@mui/lab";
import {can} from "./Permission";

const PermissionButton = ({
                              permission,
                              shopId = null,
                              visible = false,
                              icon = null,
                              title,
                              onClick,
                              color,
                              loading,
                              sx,
                              style,
                              ...otherProps
                          }) => {

    const allow = can(permission, shopId)

    if (!allow && visible === false) return null

    return (
        <LoadingButton
            variant="contained"
            loading={loading}
            type='submit'
            disabled={!allow && visible}
            onClick={onClick}
            color={color}
            sx={sx}
            style={style}
            {...otherProps}
        >
            {icon}
            {title}
        </LoadingButton>
    )
}

export default PermissionButton